import {
    Dashboard as DashboardIcon,
    Logout as LogoutIcon,
    Settings as SettingsIcon,
} from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAppContext } from "src/context/AppContext";
import { MenuButton } from "src/theme/StyledFields";
import ProfileIcon from "src/theme/icons/ProfileIcon";
import { MenuProps, getDrawerClickHandler, getMenuWrapperSx } from "./PublicPagesMenu";

const ParentMenu: React.FC<MenuProps> = ({ layout = 'drawer' }) => {
    const location = useLocation();
    const { closeDrawer } = useAppContext();

    const menuItems = [
        { path: "/dashboard", icon: DashboardIcon, label: "Dashboard", priority: true },
        // { path: "/notifications", icon: NotificationsIcon, label: "Notifications", priority: true },
        //        { path: "/users", icon: PersonIcon, label: "Users", priority: false },
        //        { path: "/payments", icon: PaymentIcon, label: "Payments", priority: false },
        //        { path: "/coach-content", icon: SportsIcon, label: "Coach Content", priority: false },
        { path: "/my-profile", icon: ProfileIcon, label: "My Account", priority: false },
    ];
    if (layout !== 'header') {
        menuItems.push({ path: "/my-profile/settings", icon: SettingsIcon, label: "Settings", priority: false });
    }

    if (layout === 'drawer') {
        menuItems.push({ path: "/account/logout", icon: LogoutIcon, label: "Logout", priority: false });
    }

    const renderItems = () => {
        return menuItems.map(({ path, icon: Icon, label }) => (
            <MenuButton
                key={path}
                component={Link}
                to={path}
                fullWidth={layout === 'drawer'}
                startIcon={<Icon fontSize="small" />}
                color={location.pathname === path ? "primary" : "inherit"}
                sx={{
                    justifyContent: layout === 'drawer' ? 'flex-start' : 'center',
                }}
                onClick={getDrawerClickHandler(layout, closeDrawer)}
            >
                {label}
            </MenuButton>
        ));
    };

    return <Box data-menu-role="parent" data-menu-layout={layout} sx={getMenuWrapperSx(layout)}>{renderItems()}</Box>;
};

export default ParentMenu;